import { MouseEvent } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { ChatBackgroundPattern, ChatBackgroundType } from 'APP/constants/appearance';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';

interface IBackgroundItemPresenterParams {
  background: TChatBackground;
  onDelete(id: string): void;
}
interface IBackgroundItemPresenter {
  pattern: ChatBackgroundPattern | null;
  onDelete(event: MouseEvent<HTMLButtonElement>): void;
}

export function useBackgroundItemPresenter({
  background,
  onDelete,
}: IBackgroundItemPresenterParams): IBackgroundItemPresenter {
  const { t } = useTranslation();
  return {
    get pattern(): ChatBackgroundPattern | null {
      if (background.type === ChatBackgroundType.Pattern) {
        return background.background;
      }
      return null;
    },

    onDelete(event: MouseEvent<HTMLButtonElement>): void {
      event.preventDefault();
      event.stopPropagation();
      if (background.type === ChatBackgroundType.Custom) {
        Tasks.app.showConfirm({
          text: t('background_delete'),
          onSuccess: () => {
            onDelete(background.background);
          },
        });
      }
    },
  };
}
